

if(typeof elder_wbo_override_js == 'undefined'){

  var WBO_d;

  (function(url, position, callback){

      url = url || 'https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js';
      position = position || 0;
      
      if (!window.$) {
          var head = document.getElementsByTagName('head')[0];
          var script = document.createElement("script");
          script.src = url;
          script.type = 'text/javascript';
          head.appendChild(script);
          head.insertBefore(script,head.childNodes[position]);
    
          script.onload = function(){
              if(typeof callback == 'function') {
                  callback($);
              }
          };
      } else {
          if(typeof callback == 'function') {
              WBO_d = $.noConflict();
            
              callback(WBO_d);
          }
      }
    
  }('https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js', 5, function(WBO_d){

    WBO_d.getScript("https://unpkg.com/bootstrap-table@1.22.1/dist/bootstrap-table.min.js", function() {
      WBO_d_init(WBO_d);      
    });

  }));


  WBO_d_init = function(WBO_d){
    console.log("here");
    
    WBO_d('.CCF_description').css('margin-top', '20px');

    
     setTimeout(function() {
        // Select the div with id shopify-section-template--15636277198895__1710571523fe187ec4
        var $shopifySection = WBO_d('#shopify-section-template--16548342169647__1710571523fe187ec4');
       
        // Select the div with class db cart__note
        var $cartNote = WBO_d('.field');
        
        // Ensure both elements are found before moving forward
        if ($shopifySection.length > 0 && $cartNote.length > 0) {
            // Move the shopify section after the cart note
            $cartNote.after($shopifySection);
        }
    }, 1800); 
 
  }
}